module.exports = __webpack_public_path__ + "img/SES_235250021.67a16983.jpg";